import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MailCheck } from 'lucide-react';
import { Button } from '../components/common/Button';
import { authApi } from '../services/api';
import restauragroLogo from '../assets/restauragro-logo.png';
import toast from 'react-hot-toast';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch (error: any) {
      const message = error.response?.data?.message || 'Não foi possível processar sua solicitação. Tente novamente.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#F7F9FF] px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <img src={restauragroLogo} alt="RestaurAgro" className="mx-auto h-16 w-16 object-contain" />
        </div>

        <div className="rounded-2xl border border-[#D0D4E4] bg-white p-8 shadow-sm">
          {sent ? (
            <div className="text-center">
              <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#E9F4EC]">
                <MailCheck size={24} className="text-[#3F8A5C]" />
              </div>
              <h2 className="text-2xl font-bold text-[#323338]">Verifique seu e-mail</h2>
              <p className="mt-2 text-sm text-[#676879]">
                Se o e-mail <strong>{email}</strong> existir em nossa base, você receberá um link para redefinir sua senha em instantes.
              </p>
              <Link
                to="/login"
                className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-[#C24914] hover:underline"
              >
                <ArrowLeft size={16} />
                Voltar para o login
              </Link>
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-bold text-[#323338]">Esqueceu sua senha?</h2>
              <p className="mt-1 text-sm text-[#676879]">
                Informe seu e-mail e enviaremos um link para redefinir sua senha.
              </p>

              <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                <div>
                  <label htmlFor="email" className="mb-1 block text-sm font-medium text-[#323338]">E-mail</label>
                  <div className="relative">
                    <Mail size={18} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#676879]" />
                    <input
                      id="email"
                      type="email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      className="w-full rounded-lg border border-[#D0D4E4] py-3 pl-10 pr-4 text-sm focus:border-[#C24914] focus:outline-none focus:ring-2 focus:ring-[#C24914]/20"
                      placeholder="voce@exemplo.com"
                      autoComplete="email"
                      required
                    />
                  </div>
                </div>

                <Button type="submit" variant="brand" loading={loading} className="w-full justify-center py-3">
                  Enviar link de redefinição
                </Button>
              </form>

              <Link
                to="/login"
                className="mt-6 flex items-center justify-center gap-2 text-sm font-medium text-[#676879] hover:text-[#323338]"
              >
                <ArrowLeft size={16} />
                Voltar para o login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
